import axios from '@/modules/marketplace/axios-marketplace';

const getPerguntas = (params) => axios.get('/fornecedor/ofertas/perguntas', {
  params,
});

export default {
  getPerguntas,
};
